import { useMemoSelector } from '@spa/redux/hooks'
import { getWeekDateParams } from '@spa/scenes/Plannings/redux/selectors'
import type { PropsWithChildren, FC } from 'react'
import React from 'react'

import { computePercentLeft } from '../utils/computePercentLeft'
import { computePercentWidth } from '../utils/computePercentWidth'
import { TUBE_ITEM_HEIGHT } from '../utils/weekLayoutConstants'

import styles from './WeekRestPositioner.module.css'

type Props = {
  item: {
    id: number
    start: string
    end: string
    offsetY: number
  }
  children?: React.ReactNode
}

const WeekRestPositioner: FC<PropsWithChildren<Props>> = React.memo(
  ({ children, item }) => {
    const { week } = useMemoSelector(getWeekDateParams)

    const left = computePercentLeft(item.start, week.start)
    const width = computePercentWidth({ item, timeRange: week })

    return (
      <div
        className={styles.Container}
        style={{
          left,
          width,
          top: item.offsetY * TUBE_ITEM_HEIGHT
        }}
      >
        {children}
      </div>
    )
  }
)

export default WeekRestPositioner
